// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Wqh4","left":"InfoRow_left__260AT"};